import { forwardRef, useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { FaTimes } from "react-icons/fa";
import CustomSearch from "../../../Common/CustomSearch";
import { getFromLocalStorage } from "../../../utils/webStorage";
import userService from "../../../services/user.service";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";
import DialogBox from "./ReusablePopup/DialogBox";

const ActiveAthleteCoachesListPopup = (
  {
    open,
    togglePopup,
    isArrayEmpty,
    setOption,
    coachesForFeed,
    athleteForFeed,
    isChecked,
    handleListSubmit,
  },
  formRef
) => {
  const schoolId = getFromLocalStorage("schoolId");
  const coachListScrollRef = useRef();
  const athleteListScrollRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    getAllCoachesData(
      columns["1"].pageState.page,
      columns["1"].pageState.pageSize
    );
    getAllAtheleteData(
      columns["2"].pageState.page,
      columns["2"].pageState.pageSize
    );
  }, []);

  const getAllCoachesData = (page, size) => {
    setColumns((prevState) => ({
      ...prevState,
      1: {
        ...prevState["1"],
        loading: true,
      },
    }));
    userService
      .getAllCoachesDropdown(schoolId, page, size)
      .then((response) => {
        const coachesDataTest = response.data.data.coaches;
        setColumns((prevState) => ({
          ...prevState,
          1: {
            ...prevState["1"],
            items:
              page === 0
                ? coachesDataTest
                : [...prevState["1"].items, ...coachesDataTest],
            loading: false,
            pageState: {
              ...prevState["1"].pageState,
              total: response.data.data.total,
              totalPages: response.data.data.totalPages,
              page: page,
            },
          },
        }));
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const getAllAtheleteData = (page, size) => {
    setColumns((prevState) => ({
      ...prevState,
      2: {
        ...prevState["2"],
        loading: true,
      },
    }));
    userService
      .getAllAtheleteDropdown(schoolId, page, size)
      .then((response) => {
        const atheleteDataTest = response.data.data.athletes;
        setColumns((prevState) => ({
          ...prevState,
          2: {
            ...prevState["2"],
            items:
              page === 0
                ? atheleteDataTest
                : [...prevState["2"].items, ...atheleteDataTest],
            loading: false,
            pageState: {
              ...prevState["2"].pageState,
              total: response.data.data.total,
              totalPages: response.data.data.totalPages,
              page: page,
            },
          },
        }));
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const onScrollCoachesList = () => {
    if (
      columns["1"].pageState.page < columns["1"].pageState.totalPages - 1 &&
      !columns["1"].loading
    ) {
      if (coachListScrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          coachListScrollRef.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          columns["1"].recordSearched
            ? searchCoaches(
                columns["1"].pageState.page + 1,
                columns["1"].pageState.pageSize
              )
            : getAllCoachesData(
                columns["1"].pageState.page + 1,
                columns["1"].pageState.pageSize
              );
        }
      }
    }
  };

  const onScrollAthletesList = () => {
    if (
      columns["2"].pageState.page < columns["2"].pageState.totalPages - 1 &&
      !columns["2"].loading
    ) {
      if (athleteListScrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          athleteListScrollRef.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          columns["2"].recordSearched
            ? searchAthletes(
                columns["2"].pageState.page + 1,
                columns["2"].pageState.pageSize
              )
            : getAllAtheleteData(
                columns["2"].pageState.page + 1,
                columns["2"].pageState.pageSize
              );
        }
      }
    }
  };

  const [columns, setColumns] = useState({
    ["1"]: {
      name: "Coaches",
      items: [],
      loading: false,
      pageState: {
        total: 0,
        page: 0,
        pageSize: 10,
        totalPages: 0,
      },
      searchQuery: "",
      handleSearch: (query, page, size) => searchCoaches(query, page, size),
      recordSearched: false,
      getDefaultData: (page, size) => getAllCoachesData(page, size),
    },
    ["2"]: {
      name: "Athletes",
      items: [],
      loading: false,
      pageState: {
        total: 0,
        page: 0,
        pageSize: 10,
        totalPages: 0,
      },
      searchQuery: "",
      handleSearch: (query, page, size) => searchAthletes(query, page, size),
      recordSearched: false,
      getDefaultData: (page, size) => getAllAtheleteData(page, size),
    },
  });

  const searchCoaches = (query, page, size) => {
    setColumns((prevState) => ({
      ...prevState,
      1: {
        ...prevState["1"],
        loading: true,
      },
    }));
    userService
      .searchActiveCoaches(query, schoolId, page, size)
      .then((res) => {
        const { coaches, total, totalPages } = res.data.data;
        setColumns((prevState) => ({
          ...prevState,
          1: {
            ...prevState["1"],
            items: coaches ? coaches : [],
            loading: false,
            pageState: {
              ...prevState["1"].pageState,
              total: total,
              totalPages: totalPages,
              page: page,
            },
            recordSearched: true,
          },
        }));
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong.",
        });
        setColumns((prevState) => ({
          ...prevState,
          1: {
            ...prevState["1"],
            loading: false,
          },
        }));
      });
  };

  const searchAthletes = (query, page, size) => {
    setColumns((prevState) => ({
      ...prevState,
      2: {
        ...prevState["2"],
        loading: true,
      },
    }));
    userService
      .searchActiveAthletes(query, schoolId, page, size)
      .then((res) => {
        const { athletes, total, totalPages } = res.data.data;
        setColumns((prevState) => ({
          ...prevState,
          2: {
            ...prevState["2"],
            items: athletes ? athletes : [],
            loading: false,
            pageState: {
              ...prevState["2"].pageState,
              total: total,
              totalPages: totalPages,
              page: page,
            },
            recordSearched: true,
          },
        }));
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong.",
        });
        setColumns((prevState) => ({
          ...prevState,
          2: {
            ...prevState["2"],
            loading: false,
          },
        }));
      });
  };

  const updateColumn = (id, value, fieldName) => {
    setColumns((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [fieldName]: value,
      },
    }));
  };

  const handleClose = () => {
    if (!isArrayEmpty) {
      if (formRef && setOption) {
        formRef?.current?.setFieldValue("shareOption", "");
        setOption("");
      }
    }
    togglePopup(false);
  };
  return (
    <DialogBox
      title={
        <div className="d-flex align-items-center justify-content-between w-100">
          <h6 className="fs-20 semi-bold">Select Coaches & Athletes</h6>
          <FaTimes onClick={handleClose} className="crossview cp" />
        </div>
      }
      open={open}
      variant="md"
      onClose={handleClose}
    >
      <div className="d-flex gap-20">
        {Object.entries(columns).map(([id, column]) => {
          return (
            <div className="columnSetBoxes-main position-relative w-100">
              {column.loading && (
                <div className="hidden-active-column-loading-container">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}
              {!column?.loading && column?.items?.length === 0 && (
                <div className="hidden-active-column-loading-container">
                  <p className="text-center bold fs-16">{`No ${column?.name} Found`}</p>
                </div>
              )}
              <div className="active-hidden-column-header">
                <h6 className="fs-22 semi-bold txt-center white mg-bottom-5">
                  {column?.name}
                </h6>
                <CustomSearch
                  searchQuery={column.searchQuery}
                  setSearchQuery={(value) =>
                    updateColumn(id, value, "searchQuery")
                  }
                  isVideoLibraryPage={true}
                  searchData={column.handleSearch}
                  getDataByPage={column.getDefaultData}
                  searchedRecord={column.recordSearched}
                  setSearchedRecord={(value) =>
                    updateColumn(id, value, "recordSearched")
                  }
                  pageState={column.pageState}
                />
              </div>
              <div className="active-hidden-column-container">
                <div
                  className={`active-hidden-column-draggable-container`}
                  onScroll={() =>
                    column.name === "Coaches"
                      ? onScrollCoachesList(id)
                      : onScrollAthletesList(id)
                  }
                  ref={
                    column.name === "Coaches"
                      ? coachListScrollRef
                      : athleteListScrollRef
                  }
                >
                  {column?.items?.map((item, index) => (
                    <div
                      key={index}
                      className="active-hidden-column-draggable-item"
                    >
                      <div className="d-flex flex-diection-row align-items-center gap-10">
                        <Checkbox
                          onChange={() => {
                            column.name === "Coaches"
                              ? coachesForFeed(item.id)
                              : athleteForFeed(item.id);
                          }}
                          icon={<BsCircle fontSize="20px" color="#13005A" />}
                          id={item.id}
                          checkedIcon={
                            <BsFillCheckCircleFill
                              fontSize="20px"
                              color="#13005A"
                            />
                          }
                          checked={isChecked(id, item.id)}
                          className="videolibrary-checkbox-icon"
                        />
                        {`${item?.firstName} ${item?.lastName}`}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="d-flex-align-right mg-top-20">
        <button
          type="button"
          className="cancelbtn mr-2"
          onClick={() => togglePopup(false)}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={!isArrayEmpty ? "saveBtn1 activv" : "saveBtn1"}
          onClick={() => {
            handleListSubmit();
          }}
          disabled={!isArrayEmpty}
        >
          Share
        </button>
      </div>
    </DialogBox>
  );
};

export default forwardRef(ActiveAthleteCoachesListPopup);
